import { isBefore } from 'date-fns';

import type { LatestImage } from '../../../@types/latestImages';
import type { VisitsResponse } from '../../../@types/visits';

export const computeSelectedVisitString = (
  patientVisitsData: VisitsResponse,
  id: number,
) => {
  const visitIndex = patientVisitsData?.visits.findIndex((v) => v.id === id);
  if (visitIndex === -1) {
    return '';
  }

  const date = new Date(patientVisitsData?.visits[visitIndex]?.visitDate || '');
  let visitType = 'Past Visit';
  if (visitIndex === 0) {
    visitType = 'Current Visit';
  }
  if (visitIndex === 1) {
    visitType = 'Last Visit';
  }

  return `${visitType} - ${date.toLocaleDateString()}`;
};

export const hasOutdatedRblAnalysis = (imageAnalyses: any): boolean => {
  const LAST_RBL_UPDATE_DATE = new Date('2023-03-03T00:00:00.000Z');

  return imageAnalyses?.some((imageAnalysis: any) => {
    const { updatedAt } = imageAnalysis;
    return isBefore(new Date(updatedAt), LAST_RBL_UPDATE_DATE);
  });
};

export const numberOfMatchingElementsBetweenTwoArrays = (
  array1: (number | string)[],
  array2: (number | string)[],
) => array1.filter((element) => array2.includes(element)).length;

export const findImageWithMaxMatchingToothNumbers = (
  idealToothArray: (string | number)[],
  latestImages: LatestImage[],
) => {
  const imageIndexWithMostMatchingToothNumbers = latestImages.reduce(
    (acc, image) => {
      const toothArray =
        image.models.tooth_identification?.findings.map(
          (finding) => finding.toothNumber,
        ) || [];
      const overlappingToothNumbers = numberOfMatchingElementsBetweenTwoArrays(
        idealToothArray,
        toothArray,
      );
      const maxNoOfOverlappingToothNumbers = Math.max(
        acc.maxVal,
        overlappingToothNumbers,
      );
      if (maxNoOfOverlappingToothNumbers === overlappingToothNumbers) {
        return {
          imageWithMaxTooth: image,
          maxVal: maxNoOfOverlappingToothNumbers,
        };
      }
      return {
        imageWithMaxTooth: acc.imageWithMaxTooth,
        maxVal: maxNoOfOverlappingToothNumbers,
      };
    },
    { imageWithMaxTooth: {} as LatestImage, maxVal: 0 },
  );
  return imageIndexWithMostMatchingToothNumbers.imageWithMaxTooth.imageId;
};
